module.exports = __webpack_public_path__ + "img/zen-pond.54879b1b.jpg";